import { MinMaxRange } from '../types/types';

export const COEFFICIENT_STANDARD_MAX: number = 10;
export const COEFFICIENT_NOT_STANDARD_RANGE: MinMaxRange = [0, 5];
export const DIMONA_RANGE: MinMaxRange = [0, 0.4965];
